import { FunctionComponent } from 'react';
import { useSelector } from 'react-redux';
import { t } from '@/utils/i18n';
import { getIsCurrentProductTypeAndAppearanceOutOfStock } from '@/redux/draft/getters/getIsCurrentProductTypeAndAppearanceOutOfStock';
import { Warning } from './Warning';

export const OutOfStockMessage: FunctionComponent = () => {
  const isOutOfStock = useSelector(getIsCurrentProductTypeAndAppearanceOutOfStock);
  return isOutOfStock ? (
    <Warning className="warning--message" message={t('general.outOfStock')} />
  ) : null;
};
